module.exports = __webpack_public_path__ + "img/inactive-risk.ad89b5a8.png";